<template>
  <v-dialog v-model="dialog" max-width="768" persistent>
    <v-card>
      <v-card-title class="text-h5 justify-space-between warning white--text">
        {{ dialogTitle || "Confirmación" }}&nbsp;
        <v-btn icon outlined @click="emitCancel" class="white--text">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <h6 class="mt-4 text-h6">
          {{ dialogMsg || "¿Desea continuar?" }}
        </h6>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="emitCancel">
          <v-icon>mdi-cancel</v-icon>&nbsp;Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn :color="confirmBtnStyle || 'primary'" @click="emitConfirm">
          <v-icon>{{ confirmBtnIcon || "mdi-check-circle-outline" }}</v-icon
          >&nbsp;{{ confirmBtnText || "Confirmar" }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog_ref: Boolean,
    dialogTitle: String,
    dialogMsg: String,
    confirmBtnText: String,
    confirmBtnIcon: String,
    confirmBtnStyle: String,
  },
  computed: {
    dialog: {
      get() {
        return this.dialog_ref;
      },
    },
  },
  methods: {
    emitCancel() {
      this.$emit("onCancel");
    },
    emitConfirm() {
      this.$emit("onConfirm");
    },
  },
};
</script>

<style>
</style>